import { render, staticRenderFns } from "./AddAgents.vue?vue&type=template&id=bef1a860&"
import script from "./AddAgents.vue?vue&type=script&lang=js&"
export * from "./AddAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports